import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import NoteLinkedEmbeddingMenu from 'notebook/embeddings/controls/NoteLinkedEmbeddingMenu';
import OpenOriginalButton from 'notebook/embeddings/controls/OpenOriginalButton';
import PreviewButton from 'notebook/embeddings/controls/PreviewButton';
import {
  DEFAULT_NOTE_LINKED_EMBEDDING_HEADER_HEIGHT,
  EmbeddingProvenance,
} from 'notebook/embeddings/NoteLinkedEmbeddingUtil';
import {GRAY_LIGHT} from 'ui-library/Colors';

export interface NoteLinkedEmbeddingHeaderProps {
  contentId: string;
  fileId: string;
  name: string;
  getEmbedding: () => React.ReactNode;
  onRename?: (newName: string) => void;
  provenance?: EmbeddingProvenance;
}

export default function NoteLinkedEmbeddingHeader({
  contentId,
  fileId,
  name,
  getEmbedding,
  onRename,
  provenance,
}: NoteLinkedEmbeddingHeaderProps): JSX.Element {
  return (
    <NoteLinkedEmbeddingMenu name={name} onRename={onRename}>
      <div className={classNames(css(styles.noteLinkedEmbeddingHeader), 'note-linked-embedding-header')}>
        <h5>{name}</h5>
        <div className={classNames(css(styles.noteLinkedEmbeddingHeaderButtons), 'hide-on-print')}>
          {provenance && <OpenOriginalButton provenance={provenance} />}
          <PreviewButton contentId={contentId} fileId={fileId} name={name} getEmbedding={getEmbedding} />
        </div>
      </div>
    </NoteLinkedEmbeddingMenu>
  );
}

const styles = StyleSheet.create({
  noteLinkedEmbeddingHeader: {
    alignItems: 'center',
    borderBottom: `1px solid ${GRAY_LIGHT}`,
    display: 'flex',
    fontWeight: 600,
    height: `${DEFAULT_NOTE_LINKED_EMBEDDING_HEADER_HEIGHT}px`,
    justifyContent: 'space-between',
    padding: '0 10px',
  },
  noteLinkedEmbeddingHeaderButtons: {
    ':not(:first-child) > *': {
      marginLeft: '6px',
    },
  },
});
